import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CartControlFormGroup } from '../../cart-control-form.component';

@Component({
  selector: 'cart-control-form-installation',
  templateUrl: './cart-control-form-installation.component.html',
  styleUrl: './cart-control-form-installation.component.scss',
  standalone: false,
})
export class CartControlFormInstallationComponent {
  @Input() formGroup: FormGroup<CartControlFormGroup>;
}
